import { METRIC_NAMES, SORT_DIRECTION, WIDGET_MODES, AGENT_STATUSES, DATA_LOADING_STATES } from '@config/Consts';
import { AGENT_LIST_RESOURCES } from './Consts';

export default {
  dataStatus: {
    [AGENT_LIST_RESOURCES.AGENT_ACTIVITY]: DATA_LOADING_STATES.NONE,
    [AGENT_LIST_RESOURCES.AGENT_VIEW]: DATA_LOADING_STATES.NONE,
    [AGENT_LIST_RESOURCES.METRICS]: DATA_LOADING_STATES.NONE,
  },
  lastTimeDataUpdated: {
    [AGENT_LIST_RESOURCES.AGENT_ACTIVITY]: null,
    [AGENT_LIST_RESOURCES.AGENT_VIEW]: null,
    [AGENT_LIST_RESOURCES.METRICS]: null,
  },
  agentsMetrics: null,
  filter: {
    status: [],
    agents: [],
  },
  widgetMode: WIDGET_MODES.TABLE,
  agentStatusSummary: {
    [AGENT_STATUSES.AWAY]: null,
    [AGENT_STATUSES.ONLINE]: null,
    [AGENT_STATUSES.BACK_SOON]: null,
  },
  sort: {
    columnName: METRIC_NAMES.AGENT_VIEW_AGENT_LOAD,
    direction: SORT_DIRECTION.DESCENDING,
  },
};
